import React, { useState } from 'react';

import { Icon, Pressable } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { A11yWrapper } from 'components/a11y-wrapper';
import { Box, Typography, withTypography } from 'components/ui';
import { t } from 'state/intl/translations';
import { getDesignToken, spacing } from 'styles/constants';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

import theme from './theme';

const PhoneNumberInformation = withTypography({
  variant: 'copyTwo',
  color: theme.phoneNumberInformationColor,
  textAlign: 'center',
  fontSize: 'xs',
  mt: '$3',
});

const PhoneNumberToggle = Pressable.withConfig({
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
});

const PhoneAddressInformationToggle = () => {
  const [visible, setVisible] = useState(false);

  return (
    <Box style={styles.container}>
      <PhoneNumberToggle onPress={() => setVisible(!visible)}>
        <Typography variant="copyTwo" bold>
          {t('whyDoYouNeedMyPhoneNumber')}
        </Typography>
        <Icon
          variant={!visible ? 'select' : 'collapse'}
          color={getDesignToken('icon-default')}
          width="24px"
          {...hiddenAccessibilityPlatformProps}
        />
      </PhoneNumberToggle>
      {visible && (
        <A11yWrapper>
          <PhoneNumberInformation testID="phoneNumberDisclaimer">
            {t('deliveryPhoneDisclosure')}
          </PhoneNumberInformation>
        </A11yWrapper>
      )}
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: spacing.$3,
  },
});

export default PhoneAddressInformationToggle;
